import React from 'react';
import PropTypes from 'prop-types';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

const BankTransferBloc = ({ i18n, paymentId }) => (
    <div className="conteneur-color">
        <p>{convertHtmlToReactDomWithParams(i18n.TEXT_IBAN_1, paymentId)}</p>
        <div className="iban">
            <p className="label">{i18n.TEXT_IBAN_2}</p>
            <p>{i18n.TEXT_IBAN_3}</p>
            <p className="label">{i18n.TEXT_IBAN_4}</p>
            <p>{i18n.TEXT_IBAN_5}</p>
            <p className="small">{i18n.TEXT_IBAN_6}</p>
            <p className="label">{i18n.TEXT_IBAN_7}</p>
            <p>{convertHtmlToReactDomWithParams(i18n.TEXT_IBAN_8)}</p>
            <p className="info">{convertHtmlToReactDomWithParams(i18n.TEXT_IBAN_9)}</p>
        </div>
    </div>
);

BankTransferBloc.propTypes = {
    i18n: PropTypes.object.isRequired,
    paymentId: PropTypes.string.isRequired
};

export default BankTransferBloc;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/erreur/BankTransferBloc.js